import React from "react";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import image1 from "../../assets/images/image1.png";
import { FiEdit } from "react-icons/fi";
import { IoEyeOutline, IoDownloadOutline, IoShareSocialOutline } from "react-icons/io5";
import { MdOutlineLocationOn, MdOutlineLabel, MdVisibility, MdOutlineBusiness } from "react-icons/md";
import { PiFilePdfFill } from "react-icons/pi";
import { useViewMedia } from "../../hooks/media/media.view";

const MultiMediaDetailPage = () => {
  const { id } = useParams();
  const { data: mediaInformation, isLoading, error } = useViewMedia(id);

  const [mediaData, setMediaData] = useState(null);

  useEffect(() => {
    if (mediaInformation?.data) {
      setMediaData(mediaInformation.data);
    }
  }, [mediaInformation]);

  console.log("Media Information:", mediaInformation);
  console.log("Selected Media ID:", id);

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '400px',
        fontSize: '16px',
        color: '#666'
      }}>
        Loading media...
      </div>
    );
  }

  if (error || !mediaData) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '400px',
        fontSize: '16px',
        color: '#e74c3c'
      }}>
        Error loading media data
      </div>
    );
  }

  return (
    <>
      <button 
        className="commonButton" 
        style={{marginLeft:"auto"}} 
        onClick={() => window.location.href = `/mediauploads/EditMultimedia/${id}`}
      >
        <FiEdit size={20} color="#ffffff" style={{ marginRight: 8 }} /> Edit Media
      </button>

      <div style={{
        padding: '20px',
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        {/* Main Content Section */}
        <div style={{
          background: '#fff',
          borderRadius: '12px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          padding: '24px',
          marginBottom: '20px',
          border: '1px solid #f0f0f0'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'auto 1fr',
            gap: '24px',
            alignItems: 'start'
          }}>
            {/* Thumbnail */}
            <div style={{
              width: '280px',
              height: '180px',
              borderRadius: '8px',
              overflow: 'hidden',
              flexShrink: 0,
              background: '#f5f5f5',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <img 
                src={mediaData?.url ? `${process.env.REACT_APP_BASE_IMAGE}${mediaData.url}` : image1}
                alt={mediaData?.title || 'Media thumbnail'}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
            </div>

            {/* Content */}
            <div>
              <h2 style={{
                fontSize: '24px',
                fontWeight: '500',
                color: '#333',
                marginBottom: '12px',
                lineHeight: '1.3'
              }}>
                {mediaData?.title || 'Untitled'}
              </h2>
              <p style={{
                fontSize: '14px',
                fontWeight: '400',
                color: '#666',
                lineHeight: '1.6',
                marginBottom: '16px'
              }}>
                {mediaData?.description || 'No description available'}
              </p>

              {/* Status Badges */}
              <div style={{
                display: 'flex',
                gap: '8px',
                flexWrap: 'wrap'
              }}>
                <span style={{
                  background: mediaData?.status === 'active' ? '#e8f5e9' : '#ffebee',
                  color: mediaData?.status === 'active' ? '#2e7d32' : '#c62828',
                  padding: '4px 12px',
                  borderRadius: '12px',
                  fontSize: '12px',
                  fontWeight: '500',
                  textTransform: 'capitalize'
                }}>
                  {mediaData?.status || 'unknown'}
                </span>
                <span style={{
                  background: '#e3f2fd',
                  color: '#0A4DA2',
                  padding: '4px 12px',
                  borderRadius: '12px',
                  fontSize: '12px',
                  fontWeight: '500',
                  textTransform: 'uppercase'
                }}>
                  {mediaData?.type || 'media'}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Analytics Cards */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '16px',
          marginBottom: '20px'
        }}>
          {/* Views Card */}
          <div style={{
            background: 'linear-gradient(135deg, #004996 0%, #0066cc 100%)',
            borderRadius: '12px',
            padding: '20px',
            boxShadow: '0 2px 8px rgba(0,73,150,0.2)',
            color: '#fff'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: '8px'
            }}>
              <span style={{
                fontSize: '13px',
                fontWeight: '400',
                opacity: 0.9
              }}>Views</span>
              <IoEyeOutline size={24} style={{opacity: 0.8}} />
            </div>
            <div style={{
              fontSize: '32px',
              fontWeight: '600'
            }}>
              {mediaData?.analytics?.views || 0}
            </div>
          </div>

          {/* Downloads Card */}
          {/* <div style={{
            background: 'linear-gradient(135deg, #003d7a 0%, #004996 100%)',
            borderRadius: '12px',
            padding: '20px',
            boxShadow: '0 2px 8px rgba(0,73,150,0.2)',
            color: '#fff'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: '8px'
            }}>
              <span style={{
                fontSize: '13px',
                fontWeight: '400',
                opacity: 0.9
              }}>Downloads</span>
              <IoDownloadOutline size={24} style={{opacity: 0.8}} />
            </div>
            <div style={{
              fontSize: '32px',
              fontWeight: '600'
            }}>
              {mediaData?.analytics?.downloads || 0}
            </div>
          </div> */}

          {/* Share Card */}
          {/* <div style={{
            background: 'linear-gradient(135deg, #0066cc 0%, #0080ff 100%)',
            borderRadius: '12px',
            padding: '20px',
            boxShadow: '0 2px 8px rgba(0,73,150,0.2)',
            color: '#fff'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: '8px'
            }}>
              <span style={{
                fontSize: '13px',
                fontWeight: '400',
                opacity: 0.9
              }}>Shares</span>
              <IoShareSocialOutline size={24} style={{opacity: 0.8}} />
            </div>
            <div style={{
              fontSize: '32px',
              fontWeight: '600'
            }}>
              {mediaData?.analytics?.share || 0}
            </div>
          </div> */}
        </div>

        {/* Metadata Section */}
        <div style={{
          background: '#fff',
          borderRadius: '12px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          padding: '24px',
          marginBottom: '20px',
          border: '1px solid #f0f0f0'
        }}>
          <h3 style={{
            fontSize: '18px',
            fontWeight: '500',
            color: '#333',
            marginBottom: '20px'
          }}>
            Media Information
          </h3>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '20px'
          }}>
            {/* Industry */}
            {mediaData?.industry && (
            <div style={{
              display: 'flex',
              alignItems: 'start',
              gap: '12px'
            }}>
              <MdOutlineLabel size={20} style={{color: '#666', marginTop: '2px'}} />
              <div>
                <div style={{
                  fontSize: '12px',
                  fontWeight: '500',
                  color: '#999',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  marginBottom: '4px'
                }}>
                  Industry
                </div>
                <div style={{
                  fontSize: '14px',
                  fontWeight: '400',
                  color: '#333'
                }}>
                  {typeof mediaData?.industry === 'string' ? mediaData.industry : mediaData?.industry?.title || 'N/A'}
                </div>
              </div>
            </div>
            )}

            {/* Country */}
            <div style={{
              display: 'flex',
              alignItems: 'start',
              gap: '12px'
            }}>
              <MdOutlineLocationOn size={20} style={{color: '#666', marginTop: '2px'}} />
              <div>
                <div style={{
                  fontSize: '12px',
                  fontWeight: '500',
                  color: '#999',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  marginBottom: '4px'
                }}>
                  Country
                </div>
                <div style={{
                  fontSize: '14px',
                  fontWeight: '400',
                  color: '#333'
                }}>
                  {mediaData?.country || 'N/A'}
                </div>
              </div>
            </div>

            {/* Tags */}
            <div style={{
              display: 'flex',
              alignItems: 'start',
              gap: '12px'
            }}>
              <MdOutlineLabel size={20} style={{color: '#666', marginTop: '2px'}} />
              <div>
                <div style={{
                  fontSize: '12px',
                  fontWeight: '500',
                  color: '#999',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  marginBottom: '4px'
                }}>
                  Tags
                </div>
                <div style={{
                  fontSize: '14px',
                  fontWeight: '400',
                  color: '#333'
                }}>
                  {typeof mediaData?.tags === 'string' ? mediaData.tags : mediaData?.tags?.name || 'N/A'}
                </div>
              </div>
            </div>

            {/* Visibility */}
            <div style={{
              display: 'flex',
              alignItems: 'start',
              gap: '12px'
            }}>
              <MdVisibility size={20} style={{color: '#666', marginTop: '2px'}} />
              <div>
                <div style={{
                  fontSize: '12px',
                  fontWeight: '500',
                  color: '#999',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  marginBottom: '4px'
                }}>
                  Visibility
                </div>
                <div style={{
                  fontSize: '14px',
                  fontWeight: '400',
                  color: '#333'
                }}>
                  {mediaData?.visibility ? 'Public' : 'Private'}
                  {mediaData?.isOffline && ' (Offline)'}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Video Player Section */}
        {mediaData?.type === 'video' && mediaData?.url && (
          <div style={{
            background: '#fff',
            borderRadius: '12px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            padding: '24px',
            border: '1px solid #f0f0f0'
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '500',
              color: '#333',
              marginBottom: '16px'
            }}>
              Video Content
            </h3>
            
            <div style={{
              position: 'relative',
              paddingBottom: '56.25%',
              height: 0,
              overflow: 'hidden',
              borderRadius: '8px',
              background: '#000'
            }}>
              <iframe
                src={mediaData?.url?.replace('youtu.be/', 'youtube.com/embed/')?.split('?')[0] || ''}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  border: 'none'
                }}
                allowFullScreen
                title={mediaData?.title || 'Video content'}
              />
            </div>
          </div>
        )}

        {/* PDF Viewer Section */}
        {mediaData?.type === 'pdf' && (
          <div style={{
            background: '#fff',
            borderRadius: '12px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            padding: '24px',
            border: '1px solid #f0f0f0'
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '500',
              color: '#333',
              marginBottom: '20px'
            }}>
              PDF Document
            </h3>

            {/* PDF File Info Card */}
            <div style={{
              background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
              borderRadius: '12px',
              padding: '24px',
              marginBottom: '20px',
              display: 'flex',
              alignItems: 'center',
              gap: '20px',
              border: '1px solid #e0e0e0'
            }}>
              <div style={{
                background: '#fff',
                borderRadius: '12px',
                padding: '20px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}>
                <PiFilePdfFill size={48} color="#e74c3c" />
              </div>
              
              <div style={{ flex: 1 }}>
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '500',
                  color: '#333',
                  marginBottom: '8px'
                }}>
                  {mediaData?.fileInfo?.originalName || 'document.pdf'}
                </h4>
                
                <div style={{
                  display: 'flex',
                  gap: '20px',
                  flexWrap: 'wrap'
                }}>
                  <span style={{
                    fontSize: '13px',
                    color: '#666',
                    fontWeight: '400'
                  }}>
                    <strong style={{ fontWeight: '500' }}>Size:</strong> {mediaData?.fileInfo?.sizeInMB?.toFixed(2) || '0'} MB
                  </span>
                  <span style={{
                    fontSize: '13px',
                    color: '#666',
                    fontWeight: '400'
                  }}>
                    <strong style={{ fontWeight: '500' }}>Type:</strong> {mediaData?.fileInfo?.mimeType || 'application/pdf'}
                  </span>
                  <span style={{
                    fontSize: '13px',
                    color: '#666',
                    fontWeight: '400'
                  }}>
                    <strong style={{ fontWeight: '500' }}>Extension:</strong> {mediaData?.fileInfo?.extension || '.pdf'}
                  </span>
                </div>
              </div>

              <a
                href={`${process.env.REACT_APP_BASE_IMAGE}${mediaData?.url}`}
                download
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  background: 'linear-gradient(135deg, #004996 0%, #0066cc 100%)',
                  color: '#fff',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontSize: '14px',
                  fontWeight: '500',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  boxShadow: '0 2px 8px rgba(0,73,150,0.2)',
                  transition: 'transform 0.2s ease',
                  whiteSpace: 'nowrap'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,73,150,0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,73,150,0.2)';
                }}
              >
                <IoDownloadOutline size={18} />
                Download
              </a>
            </div>

            {/* PDF Preview */}
            <div style={{
              borderRadius: '8px',
              overflow: 'hidden',
              border: '1px solid #e0e0e0',
              background: '#f5f5f5',
              minHeight: '600px'
            }}>
              <iframe
                src={`${process.env.REACT_APP_BASE_IMAGE}${mediaData?.url}#toolbar=1`}
                style={{
                  width: '100%',
                  height: '600px',
                  border: 'none'
                }}
                title={mediaData?.title || 'PDF Document'}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MultiMediaDetailPage;
